import { ConfigType } from "../utils/requestAPI";

export type paginationType = {
  limit?: number;
  total?: number;
  totalPages?: number;
  currentPage?: number;
  page?: number;
  search?: string;
  type?: string;
};

const jobs = {
  getJobs: (params?: paginationType): ConfigType => {
    return {
      method: "get",
      url: "jobs",
      params,
    };
  },
  getSingleJob: (id: string): ConfigType => {
    return {
      method: "get",
      url: `jobs/${id}`,
    };
  },
  getTradeCategories: (): ConfigType => {
    return {
      method: "get",
      url: "trade-categories",
    };
  },
  postTradeCategories: (data: {
    title: string;
    images: string[] | string;
  }): ConfigType => {
    return {
      method: "post",
      url: "trade-categories",
      data,
    };
  },
  updateTradeCategories: (
    id: string,
    data: {
      title: string;
      images: string[];
    }
  ): ConfigType => {
    return {
      method: "put",
      url: `trade-categories/${id}`,
      data,
    };
  },
  deleteTradeCategories: (id: string): ConfigType => {
    return {
      method: "delete",
      url: `trade-categories/${id}`,
    };
  },
};

export default jobs;
